import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconVolumeMidStyle0 = cosmosIconCss;

const CosmosIconVolumeMid$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconVolumeMid extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '4e7bb93f9177b24b2623615cabdd3c04f3c33d4a', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '9ae36ef0d1584965119ef897c8cbefe83fc699ac', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '81a003db9e639924910e3b519241943b6ab95077', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m7.62 8 2.55-2.29a.5.5 0 0 1 .83.37v9.81a.5.5 0 0 1-.83.37L7.61 14H4.5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h3.12Zm5.38.06.37-.37a.5.5 0 0 1 .69-.05 4.59 4.59 0 0 1-.09 6.61.5.5 0 0 1-.69 0l-.35-.36a.51.51 0 0 1 0-.68 3.42 3.42 0 0 0 1-2.28 3.14 3.14 0 0 0-.93-2.2.49.49 0 0 1 0-.67Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconVolumeMidStyle0; }
}, [1, "cosmos-icon-volume-mid", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-volume-mid"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-volume-mid":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconVolumeMid$1);
            }
            break;
    } });
}

const CosmosIconVolumeMid = CosmosIconVolumeMid$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconVolumeMid, defineCustomElement };
